module.exports = __webpack_public_path__ + "img/highlights-1.2fe2aa10.svg";